"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouterDailyTVLSchema = exports.SlippageUpdateSchema = exports.RelayerFeesIncreaseSchema = exports.BidStatusSchema = exports.RouterBalanceSchema = exports.AssetPriceSchema = exports.AssetBalanceSchema = exports.AssetSchema = exports.ExecuteArgsSchema = exports.XCallArgsSchema = exports.DestinationTransferSchema = exports.OriginTransferSchema = exports.XTransferSchema = exports.TransferIdInformationSchema = exports.XTransferDestinationSchema = exports.XTransferOriginSchema = exports.XTransferMethodCallSchema = exports.XTransferMessageStatus = exports.XTransferErrorStatus = exports.XTransferStatus = void 0;
const typebox_1 = require("@sinclair/typebox");
const primitives_1 = require("./primitives");
exports.XTransferStatus = {
    XCalled: "XCalled",
    Executed: "Executed",
    Reconciled: "Reconciled",
    CompletedFast: "CompletedFast",
    CompletedSlow: "CompletedSlow",
};
exports.XTransferErrorStatus = {
    LowSlippage: "LowSlippage",
    LowRelayerFee: "LowRelayerFee",
    ExecutionError: "ExecutionError",
    NoBidsReceived: "NoBidsReceived",
};
exports.XTransferMessageStatus = {
    XCalled: "XCalled",
    SpokeRootSent: "SpokeRootSent",
    SpokeRootArrivedOnHub: "SpokeRootArrivedOnHub",
    AggregateRootPropagated: "AggregateRootPropagated",
    AggregatedRootArrivedOnSpokeDomain: "AggregatedRootArrivedOnSpokeDomain",
    Processed: "Processed",
};
exports.XTransferMethodCallSchema = typebox_1.Type.Object({
    caller: primitives_1.TAddress,
    transactionHash: typebox_1.Type.String(),
    timestamp: typebox_1.Type.Number(),
    gasPrice: primitives_1.TIntegerString,
    gasLimit: primitives_1.TIntegerString,
    blockNumber: typebox_1.Type.Number(),
    txOrigin: typebox_1.Type.Optional(primitives_1.TAddress),
});
exports.XTransferOriginSchema = typebox_1.Type.Object({
    chain: primitives_1.TIntegerString,
    // Event Data
    messageHash: typebox_1.Type.String(),
    // Failure reason
    errorStatus: typebox_1.Type.Optional(typebox_1.Type.Enum(exports.XTransferErrorStatus)),
    // message status
    messageStatus: typebox_1.Type.Optional(typebox_1.Type.Enum(exports.XTransferMessageStatus)),
    // Assets
    assets: typebox_1.Type.Object({
        transacting: typebox_1.Type.Object({
            asset: typebox_1.Type.String(),
            amount: primitives_1.TIntegerString,
        }),
        bridged: typebox_1.Type.Object({
            asset: typebox_1.Type.String(),
            amount: primitives_1.TIntegerString,
        }),
    }),
    relayerFees: typebox_1.Type.Record(typebox_1.Type.String(), primitives_1.TIntegerString),
    // XCall Transaction
    xcall: typebox_1.Type.Intersect([exports.XTransferMethodCallSchema]),
});
exports.XTransferDestinationSchema = typebox_1.Type.Object({
    chain: primitives_1.TIntegerString,
    // Event Data
    status: typebox_1.Type.Enum(exports.XTransferStatus),
    // Both Executed and Reconciled events emit `routers`.
    routers: typebox_1.Type.Array(primitives_1.TAddress),
    updatedSlippage: typebox_1.Type.Optional(primitives_1.TIntegerString),
    // Assets
    assets: typebox_1.Type.Object({
        // Transacting assets only come from Executed event.
        transacting: typebox_1.Type.Optional(typebox_1.Type.Object({
            asset: typebox_1.Type.String(),
            amount: primitives_1.TIntegerString,
        })),
        // Local asset comes from Reconciled and Executed events.
        local: typebox_1.Type.Object({
            asset: typebox_1.Type.String(),
            amount: primitives_1.TIntegerString,
        }),
    }),
    // Execute Transaction
    execute: typebox_1.Type.Optional(typebox_1.Type.Intersect([
        exports.XTransferMethodCallSchema,
        typebox_1.Type.Object({
            // Executed Event Data
            originSender: typebox_1.Type.Optional(primitives_1.TAddress),
        }),
    ])),
    // Reconcile Transaction
    reconcile: typebox_1.Type.Optional(exports.XTransferMethodCallSchema),
});
exports.TransferIdInformationSchema = typebox_1.Type.Object({
    originDomain: typebox_1.Type.String(),
    destinationDomain: typebox_1.Type.String(),
    canonicalDomain: typebox_1.Type.String(),
    to: primitives_1.TAddress,
    delegate: primitives_1.TAddress,
    receiveLocal: typebox_1.Type.Boolean(),
    callData: typebox_1.Type.String(),
    slippage: primitives_1.TIntegerString,
    originSender: primitives_1.TAddress,
    bridgedAmt: typebox_1.Type.String(),
    normalizedIn: primitives_1.TIntegerString,
    nonce: typebox_1.Type.Number(),
    canonicalId: typebox_1.Type.String(),
});
exports.XTransferSchema = typebox_1.Type.Intersect([
    typebox_1.Type.Object({
        transferId: typebox_1.Type.String(),
        // Call Params
        // NOTE: TransferInfo is emitted by XCalled and Executed events, but not Reconciled event.
        xparams: exports.TransferIdInformationSchema,
    }),
    typebox_1.Type.Object({
        origin: typebox_1.Type.Optional(exports.XTransferOriginSchema),
        destination: typebox_1.Type.Optional(exports.XTransferDestinationSchema),
    }),
]);
exports.OriginTransferSchema = typebox_1.Type.Intersect([
    typebox_1.Type.Object({
        transferId: typebox_1.Type.String(),
        xparams: exports.TransferIdInformationSchema,
    }),
    typebox_1.Type.Object({
        origin: exports.XTransferOriginSchema,
        destination: typebox_1.Type.Optional(exports.XTransferDestinationSchema),
    }),
]);
exports.DestinationTransferSchema = typebox_1.Type.Intersect([
    typebox_1.Type.Object({
        transferId: typebox_1.Type.String(),
        xparams: typebox_1.Type.Object({
            originDomain: typebox_1.Type.String(),
            destinationDomain: typebox_1.Type.String(),
            canonicalDomain: typebox_1.Type.String(),
            to: primitives_1.TAddress,
            delegate: primitives_1.TAddress,
            receiveLocal: typebox_1.Type.Boolean(),
            callData: typebox_1.Type.String(),
            slippage: typebox_1.Type.Optional(primitives_1.TIntegerString),
            originSender: primitives_1.TAddress,
            bridgedAmt: typebox_1.Type.String(),
            normalizedIn: primitives_1.TIntegerString,
            amount: primitives_1.TIntegerString,
            nonce: typebox_1.Type.Optional(typebox_1.Type.Number()),
            canonicalId: typebox_1.Type.String(),
        }),
    }),
    typebox_1.Type.Object({
        origin: typebox_1.Type.Optional(exports.XTransferOriginSchema),
        destination: exports.XTransferDestinationSchema,
    }),
]);
exports.XCallArgsSchema = typebox_1.Type.Object({
    destination: typebox_1.Type.String(),
    to: primitives_1.TAddress,
    asset: primitives_1.TAddress,
    delegate: primitives_1.TAddress,
    amount: primitives_1.TIntegerString,
    slippage: primitives_1.TIntegerString,
    callData: typebox_1.Type.String(),
    relayerFee: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.ExecuteArgsSchema = typebox_1.Type.Object({
    params: exports.TransferIdInformationSchema,
    routers: typebox_1.Type.Array(primitives_1.TAddress),
    routerSignatures: typebox_1.Type.Array(typebox_1.Type.String()),
    sequencer: primitives_1.TAddress,
    sequencerSignature: typebox_1.Type.String(),
});
exports.AssetSchema = typebox_1.Type.Object({
    id: primitives_1.TAddress,
    key: typebox_1.Type.String(),
    decimal: primitives_1.TIntegerString,
    adoptedAsset: primitives_1.TAddress,
    canonicalId: typebox_1.Type.String(),
    canonicalDomain: typebox_1.Type.String(),
    localAsset: primitives_1.TAddress,
    blockNumber: typebox_1.Type.String(),
    domain: typebox_1.Type.String(),
});
exports.AssetBalanceSchema = typebox_1.Type.Intersect([
    exports.AssetSchema,
    typebox_1.Type.Object({
        balance: primitives_1.TIntegerString,
        locked: primitives_1.TIntegerString,
        supplied: primitives_1.TIntegerString,
        removed: primitives_1.TIntegerString,
        feesEarned: primitives_1.TIntegerString,
    }),
]);
exports.AssetPriceSchema = typebox_1.Type.Object({
    canonicalId: typebox_1.Type.String(),
    canonicalDomain: typebox_1.Type.String(),
    timestamp: typebox_1.Type.Number(),
    price: typebox_1.Type.Number(),
});
exports.RouterBalanceSchema = typebox_1.Type.Object({ router: primitives_1.TAddress, assets: typebox_1.Type.Array(exports.AssetBalanceSchema) });
exports.BidStatusSchema = typebox_1.Type.Object({
    timestamp: typebox_1.Type.String(),
    attempts: typebox_1.Type.Number(),
});
exports.RelayerFeesIncreaseSchema = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    transferId: primitives_1.TBytes32,
    increase: primitives_1.TIntegerString,
    asset: primitives_1.TAddress,
    domain: typebox_1.Type.String(),
    timestamp: primitives_1.TIntegerString,
});
exports.SlippageUpdateSchema = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    transferId: primitives_1.TBytes32,
    slippage: primitives_1.TIntegerString,
    domain: typebox_1.Type.String(),
    timestamp: typebox_1.Type.Number(),
});
exports.RouterDailyTVLSchema = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    asset: primitives_1.TAddress,
    router: primitives_1.TAddress,
    domain: typebox_1.Type.String(),
    timestamp: typebox_1.Type.Number(),
    balance: primitives_1.TIntegerString,
});
//# sourceMappingURL=xtransfers.js.map